import { ACTIVITY_ID } from "../../Configuration";
import { FILE_CHARACTERS_UNALLOWED, GOOGLE_API_KEY, MAX_FILE_SIZE } from "../constants/globalConstants";
import { getFileExtensionByFileName } from "./fileHelpers";
import axios from "axios";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY!; 

export function encryptHeader(value: string): string {
  return CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
}

export function decryptHeader(cipherText: string): string {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}

export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


export function validateUSPhoneNumber(phone:string) {
  const cleaned = phone.replace(/[\s-.()]/g, '');

  const normalized = cleaned.startsWith('+1') ? cleaned.slice(2) :
                     cleaned.startsWith('1') && cleaned.length === 11 ? cleaned.slice(1) :
                     cleaned;
  if (!/^[0-9][0-9]{2}[0-9][0-9]{6}$/.test(normalized)) {
    return false;
  }

  return true;
}

export const dateFormat = (date) =>{

// Format as MM/DD/YYYY HH:mm
const formatted = date.toLocaleString("en-US", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
});
return formatted
}
export function validateEmail(email:string) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email.trim());  
}

export function validateZipCode(zip:string) {
  const zipRegex = /^\d{5}(-\d{4})?$/;
  return zipRegex.test(zip.trim());
}

export function onChangeNumberField(number:string){
const value = (number ?? '').replace(/[^0-9-]/g, '')
return value
}

export function onChangeTextField(number:string){
const value = (number ?? '').replace(/[^a-zA-Z0-9 ]/g, '')
return value
}
export function onChangeEmailField(number:string){
const value = (number ?? '').replace(/[^a-zA-Z0-9@._+-]/g, '')
return value
}

export function onChangeZipCodeField(value: string) {
  const cleaned = value !== undefined ? value.replace(/\D/g, "") : "";
  if (cleaned.length <= 5) return cleaned;
  return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`;
}

export function formatPlacement(event: React.ChangeEvent<HTMLInputElement>) {
  const native = event.nativeEvent as InputEvent;
  const input = event.target;
  const cursor = input.selectionStart ?? 0;
  const atEnd = cursor === input.value.length;
  if ( !(native.inputType === "deleteContentBackward" || native.inputType === "deleteContentForward") && atEnd ) {
    return;
  }
  requestAnimationFrame(() => {
    input.setSelectionRange(cursor, cursor);
  });
}
export const onChangeUSPhoneNumber = (value: string) => {
    const cleaned = value !== undefined ? value.replace(/\D/g, "") : "";
    const length = cleaned.length;
    if (length < 4) return cleaned;
    if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };

  export const getGVWFromVIN = (value: string) => {
    let maxLbs=''
const match = (value ?? '').match(/(\d{1,3}(?:,\d{3})+|\d+)\s*lb/);

if (match) {
  maxLbs = (parseInt(match[1].replace(/,/g, ''))).toLocaleString('en-US');
  
}
return maxLbs
  }
export const validateFile = (file: File, supportedFiles: string[]): [boolean, Array<any>] => {
  let valid = true
  const errors: Array<any> = []
  const FileTypes = supportedFiles
  const ext = getFileExtensionByFileName(file.name)
  if (file.size > MAX_FILE_SIZE) {
    errors.push({ fileName: `${file.name}`, message: 'File cannot exceed 25MB.' })
    valid = false
  }
  if (FileTypes.indexOf(ext) === -1) {
    errors.push({ fileName: `${file.name}`, message: `File type is not allowed. Acceptable file types are ${FileTypes.join(', ')}.` })
    valid = false
  }
  if (FILE_CHARACTERS_UNALLOWED.some(char => file.name.includes(char))) {
    errors.push({ fileName: `${file.name}`, message: `The file(s) were not uploaded because the file name(s) contain unallowed characters are ${FILE_CHARACTERS_UNALLOWED.join(' ')}.` })
    valid = false
  }
  return [valid, errors]
}

export function DocumentIconNames(file: string): string {
  const fileExtension = file?.split('.').pop() ? file?.split('.')?.pop()?.toLowerCase() : ''

  const iconName = (
    fileExtension === 'ppt' || fileExtension === 'pptx'
      ? 'icon-rb-ms-ppt-pages icon-pptcolor'
      : fileExtension === 'pdf'
      ? 'icon-file-pdf-fill icon-pdfcolor icon-rb-file-pdf-earmark'
      : fileExtension === 'doc' || fileExtension === 'docx'
      ? 'icon-rb-ms-word-file color-primary'
      : fileExtension === 'xlsx' || fileExtension === 'xls'
      ? 'icon-excel icon-excelcolor icon-rb-ms-excel-report'
      : fileExtension === 'txt'
      ? 'icon-file-doc color-primary mb-1'
      : fileExtension === 'png' 
      ? 'icon-image icon-png-jpgcolor icon-rb-file-png '
      : fileExtension === 'jpg' || fileExtension === 'jpeg'
      ? 'icon-rb-file-jpg'
      : fileExtension === 'msg'
      ? 'icon-rb-email'
      : 'icon-emptyfile'
  )
  return iconName
}


export function deepNestedEqual(a: any, b: any): boolean {
  if (a === b) return true;
  if (typeof(a) === 'string' && typeof(b) === 'string' && a?.trim() === b?.trim()) return true;

  if (typeof a !== typeof b) return false;

  if (a === null || b === null) return a === b;

  if (typeof a !== 'object') return a === b;

  if (Array.isArray(a)) {
    if (!Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    return a.every((item, index) => deepNestedEqual(item, b[index]));
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key)) return false;
    if (!deepNestedEqual(a[key], b[key])) return false;
  }

  return true;
}



export const getGeocodeAndParse = async (inputAddress) => {
  try {
    const response = await axios.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        params: {
          address: inputAddress,
          key: GOOGLE_API_KEY,
        },
      }
    );

    if (response?.data?.status !== "OK" || !response.data.results?.length) {
      console.warn("No results found for address:", inputAddress);
      return null;
    }

    const result = response.data.results[0];
    const components = result.address_components;

    const get = (type) =>
      components.find((c) => c?.types?.includes(type))?.long_name || "";

    return {
      streetName: result.formatted_address,
      city: get("locality") || get("sublocality") || get("postal_town"),
      county: get("administrative_area_level_2"),
      state: get("administrative_area_level_1"),
      zipCode: get("postal_code"),
      location: result.geometry?.location,
      raw: result, // in case you need more details later
    };
  } catch (err) {
    console.error("Error fetching geocode:", err);
    return null;
  }
};

export const scrollToTop = () => {
  const wrapper = document.getElementById('wrapper');
  if (wrapper) {
    wrapper.scrollTo({
      top: 0,
      behavior: 'smooth' // or 'auto'
    });
  }
};
export const scrollToTopFn = () => {
  const wrappers = document.querySelectorAll('.settings-main, .modalpopupbody, .content-management-height');
  wrappers.forEach(wrapper => {
    wrapper.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};



export function maskUserLoginEmailOrMobileNumber(phone: string): string {
    if (phone.length < 5) return phone;
    return phone.slice(0, 3) + "*****" + phone.slice(-2);
  }

  export const validateUserLoginRegisteredMobile = (value: string) => {
    const cleaned = value.replace(/[+\s-()]/g, "");
    const regex = /^[0-9]{10}$/;
    return regex.test(cleaned);
  };

  export const validateUserLoginMobile = (value: string) => {
    const cleaned = value.replace(/[\s-()]/g, "");
    const usRegex = /^(\+1|1)?[2-9]\d{9}$/;
    return  usRegex.test(cleaned);
  };

 export const validateUserLoginEmail = (value: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  export const validateUserLoginMobileWithRegionCode = (value: string) => {
  const cleaned = value.replace(/[\s-()]/g, ""); 
  
  // US rules (valid NANP numbers start with 2-9)
  const usRegex = /^(\+1|1)?[2-9]\d{9}$/;
  if (/^\d{10}$/.test(cleaned)) {
   return false;
  }
  if (usRegex.test(cleaned)) {
    return true
  }
  return false;
};


export const getWorkflowTransitionActivityId = (
  targetStatusCode: number,
  statusMetadata: Array<{ StatusCode: number }> | undefined,
) => {
  if (!statusMetadata?.length) {
    return ""
  }

  if (targetStatusCode === statusMetadata[5]?.StatusCode) {
    return ACTIVITY_ID.NewWorkOrder
  }

  return ""
}